module.exports = __webpack_public_path__ + "static/img/jpj-logo.9ab56b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpj-logo.jpg
// module id = TRQp
// module chunks = 175